import React, { useState } from 'react'
import { Button, Grid, Paper, Typography } from '@material-ui/core'
import { NavigateNext } from '@material-ui/icons'
import { useStyles } from '../styles'

function ContinueCard({ action, disable }) {

  const classes = useStyles()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleClick = () => {
    setLoading(true)
    action().then(_ => {
      setLoading(false)
    }).catch(_ => {
      setError('Some error occurred. Please click again.')
      setLoading(false)
    })
  }

  return (
    <div className='ContinueCard'>
        <Paper className={classes.normalCard}>
          <Grid container spacing={2}>
            <Grid container item xs={12} justifyContent='center'>
              <Button variant='contained' color='primary' onClick={handleClick} disabled={loading || disable}>
                {'Continue '}<NavigateNext />
              </Button>
            </Grid>
            {error &&
              <Grid container item xs={12} justifyContent='center'>
                <Typography variant='body2' color='error'>
                  {error}
                </Typography>
              </Grid>
            }
          </Grid>
        </Paper>
    </div>
  )
}

export default ContinueCard
